export default {
    general: {
        cancel:    'Cancel',
        save:      'Save',
        sign_out:  'Sign out',
        more_info: 'More information',
        loading:   'Loading…',
    },
    brand: {
        product_name: 'Imprion ID',
        tagline:      'Imprion sign-in',
    },
    color_mode: {
        switch_to_light: 'Switch to light mode',
        switch_to_dark:  'Switch to dark mode',
    },
    login: {
        title:             'Sign in',
        title_refresh:     'Confirm it’s you',
        title_aal2:        'Two-step verification',
        title_passkey:     'Confirm with your passkey',
        or:                'or',
        too_many_attempts: 'Too many failed attempts. Try again later.',
        signing_in_as:     'Signing in as {email}',
        other_account:     'Use a different account',
        passkey_instead:   'Use passkey instead',
        totp_instead:      'Use authenticator app instead',
    },
    passkey: {
        failed:      'The passkey could not be used. Try again.',
        unsupported: 'This browser does not support passkeys.',
    },
    settings: {
        title:                 'Account',
        second_factor_pending: 'Two-step verification is not complete',
        expired:               'The form expired. Try again.',
        setup: {
            title:    'Secure your account',
            required: 'Your account needs a password and a second factor before you can continue signing in.',
        },
        profile: {
            title: 'Personal details',
            name:  'Name',
            email: 'E-mail',
            edit:  'Edit',
        },
        password: {
            title:  'Password',
            change: 'Change password',
            set:    'A password is set.',
        },
        totp: {
            title:        'Authenticator app',
            enrolled:     'The authenticator app is set up.',
            enrol:        'Set up',
            not_enrolled: 'Not set up.',
        },
        passkey: {
            title:        'Passkeys',
            none:         'No passkeys yet.',
            unnamed:      'Passkey',
            added:        'Added {date}',
            add:          'Add passkey',
            remove:       'Remove',
            last_passkey: 'This is the only passkey of the account and cannot be removed.',
        },
    },
    invite: {
        title:   'Accept invitation',
        sign_in: 'Sign in',
        invalid: 'This invitation is not valid. Ask your administrator for a new one.',
        expired: 'This invitation has expired. Ask your administrator for a new one.',
    },
    enrol: {
        title_password:  'Set a password',
        title_choose:    'Add a second factor',
        title_totp:      'Set up the authenticator app',
        title_passkey:   'Create a passkey',
        title_done:      'Setup complete',
        choose_totp:     'Authenticator app',
        choose_passkey:  'Passkey',
        create_passkey:  'Create passkey',
        back:            'Back',
        done:            'Your account is ready. Sign in to continue.',
        session_expired: 'The invitation session has ended. Ask your administrator for a new invitation.',
    },
    error: {
        title:     'Something went wrong',
        messages: {
            generic:        'The request could not be completed.',
            expired:        'This sign-in request has expired or was already used. Start again from the app.',
            server:         'The sign-in service had a problem. Try again in a moment.',
            denied:         'Access was denied.',
            login_required: 'You need to sign in again.',
            bad_request:    'The app sent a sign-in request that could not be accepted. Contact the administrator of the app.',
        },
        reference: 'Reference: {reference}',
        to_login:  'Go to sign-in',
    },
    logout: {
        question:   'Sign out of Imprion ID in this browser?',
        confirm:    'Sign out',
        cancel:     'Cancel',
        title:      'Sign out',
        signed_out: 'You are signed out.',
        to_login:   'Sign in',
    },
    logout_confirm: {
        title:        'Sign out of all Imprion apps?',
        scope:        'This signs you out in this browser only, as far as each app allows. Other devices stay signed in.',
        requested_by: 'Requested by {name}',
        not_allowed:  'This app cannot sign you out of all Imprion apps.',
        back:         'Back to the app',
        gone:         'This sign-out request is no longer valid.',
        retry:        'The sign-out could not be completed. Try again.',
        try_again:    'Try again',
    },
    errors: {
        generic_error: 'An error occurred',
        invalid_data:  'Invalid data',
        not_found:     'Not found',
        unauthorized:  'Not authorized',
    },
    validation: {
        required: 'This field is required',
        email:    'Invalid email address',
    },
    // Kratos labels and messages, keyed by Kratos's own message id (libs/kratosUi.ts). An id
    // without an entry shows Kratos's English text.
    kratos: {
        fields: {
            traits_email:      'E-mail',
            traits_name_first: 'First name',
            traits_name_last:  'Last name',
        },
        messages: {
            1010001: 'Sign in',
            1010003: 'Please confirm this action by verifying that it is you.',
            1010004: 'Please complete the second authentication challenge.',
            1010006: 'Authentication code',
            1010009: 'Verify code',
            1010013: 'Continue',
            1010021: 'Sign in with passkey',
            1010022: 'Sign in with password',
            1050001: 'Your changes have been saved.',
            1050004: 'Turn off authenticator app',
            1050005: 'Authenticator app QR code',
            1050017: 'This is your authenticator app secret. Use it if you cannot scan the QR code.',
            1050019: 'Add passkey',
            1070001: 'Password',
            1070003: 'Save',
            1070006: 'Verification code',
            1070009: 'Continue',
            1070010: 'Invitation code',
            4000002: 'Property {property} is missing.',
            4000005: 'The password cannot be used: {reason}',
            4000006: 'The e-mail address or password is incorrect.',
            4000008: 'The authentication code is invalid. Try again.',
            4000031: 'The password cannot be used because it is too similar to the e-mail address.',
            4000032: 'The password must be at least {min_length} characters long, but has {actual_length}.',
            4000033: 'The password must be at most {max_length} characters long, but has {actual_length}.',
            4000034: 'The password has appeared in data breaches and can no longer be used.',
            4010001: 'The sign-in form has expired. Try again.',
            4050001: 'The form has expired. Try again.',
            4060006: 'The code is invalid or has already been used. Try again.',
        },
    },
}
